import { Tooltip } from './types';

const tooltipTheme: Tooltip = {
	colors: {
		dark: {
			background: 'neutral.700',
			text: 'neutral.0'
		},
		light: {
			background: 'neutral.100',
			text: 'neutral.700'
		}
	}
};
export default tooltipTheme;
